<template>
  <div class="flex text-white text-sm">
    <div
      v-for="(item, index) in props.items"
      :key="index"
      @click="
        navigate(`${item.route}`, { idConstructionProject: props.idItem })
      "
      class="flex items-center h-9 px-2 bg-blue-600 hover:bg-blue-900 cursor-pointer border-r-2 border-primary-800"
      :class="{'rounded-l-lg': index == 0, 'rounded-r-lg': index === items.length - 1}"
    >
      <i class="fa-solid" :class="[item.icon, item.label ? 'mr-2 mt-1' : '']"></i>
      <span>{{ item.label }}</span>
    </div>
  </div>
</template>
<script setup>
import { useRouter } from 'vue-router'

const props = defineProps({
    items: {
        type: Array,
        required: true
    },
    idItem:{
        type: String,
        required: true
    }
})
const router = useRouter()

const navigate = (routeName, paramObj) => {
  let route = {
    name: routeName
  }
  if (paramObj) {
    route.params = paramObj
  }
  router.push(route)
}
</script>
